import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Card, CardBody, CardHeader,
  Container, Row, Col, Badge, Button, Table,
} from "reactstrap";
import { businessesRepo } from "data/repositories/businessesRepo";
import { categoryLabel } from "labels/tr";
import EmptyState from "components/EmptyState";

export default function PartnerMyBusinesses() {
  const [businesses, setBusinesses] = useState([]);

  useEffect(() => {
    setBusinesses(businessesRepo.list());
  }, []);

  const handleRemove = (id) => {
    if (!window.confirm("Bu işletmeyi silmek istediğinize emin misiniz?")) return;
    businessesRepo.remove(id);
    setBusinesses(businessesRepo.list());
  };

  return (
    <>
      <div className="header bg-gradient-warning pb-6 pt-5 pt-md-7">
        <Container fluid>
          <Row className="align-items-center">
            <Col>
              <h2 className="text-white mb-0">İşletmelerim</h2>
            </Col>
            <Col className="text-right">
              <Button color="white" size="sm" tag={Link} to="/admin/partner/businesses/new">
                + Yeni İşletme
              </Button>
            </Col>
          </Row>
        </Container>
      </div>

      <Container className="mt--6" fluid>
        <Card className="shadow">
          <CardHeader><h3 className="mb-0">Tüm İşletmelerim</h3></CardHeader>
          <CardBody>
            {businesses.length === 0 ? (
              <EmptyState title="Henüz işletmeniz yok" />
            ) : (
              <Table className="align-items-center" responsive>
                <thead className="thead-light">
                  <tr>
                    <th>Ad</th>
                    <th>Kategori</th>
                    <th>Şehir</th>
                    <th>Owner</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {businesses.map((b) => (
                    <tr key={b.id}>
                      <td>{b.name}</td>
                      <td><Badge color="info">{categoryLabel(b.category)}</Badge></td>
                      <td>{b.location?.provinceId || "-"}</td>
                      <td>{b.ownerUserId || "-"}</td>
                      <td>
                        <Button color="primary" size="sm" className="mr-1" tag={Link} to={`/admin/partner/businesses/${b.id}`}>
                          Düzenle
                        </Button>
                        <Button color="danger" size="sm" onClick={() => handleRemove(b.id)}>
                          Arşivle
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </CardBody>
        </Card>
      </Container>
    </>
  );
}
